import React, { ReactNode, useMemo } from 'react';
import {
  PostHogProvider as PostHogNativeProvider,
  usePostHog,
} from 'posthog-react-native';
import { EventsProvider } from '@/contexts/EventsProvider/EventsContext';
import { createPostHogProvider } from '@/api/services/events';
import { posthog } from '@/contexts/EventsProvider/posthogClient';

interface PostHogEventsProviderProps {
  children: ReactNode;
  onInitialized?: () => void;
}

export const PostHogEventsProvider: React.FC<PostHogEventsProviderProps> = ({
  children,
  onInitialized,
}) => {
  return (
    <PostHogNativeProvider autocapture={false} client={posthog}>
      <PostHogEventsProviderInner onInitialized={onInitialized}>
        {children}
      </PostHogEventsProviderInner>
    </PostHogNativeProvider>
  );
};

interface PostHogEventsProviderInnerProps {
  children: ReactNode;
  onInitialized?: () => void;
}

const PostHogEventsProviderInner: React.FC<PostHogEventsProviderInnerProps> = ({
  children,
  onInitialized,
}) => {
  const posthog = usePostHog();

  const provider = useMemo(() => createPostHogProvider(posthog), [posthog]);

  return (
    <EventsProvider provider={provider} onInitialized={onInitialized}>
      {children}
    </EventsProvider>
  );
};
